export const COUNTDOWN_INTERVAL = 1000;
export const TWO_DAYS_MS = 48 * 60 * 60 * 1000;

export interface ITimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export interface IDiscountTimeParams {
    discountEndDateFromSettings?: string;
    discountEndTime?: string;
}

export const ZERO_TIME_LEFT: ITimeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
};
